import React, { useState } from 'react'

import PropTypes from 'prop-types'

import UserAction from './UserTableAction'
import DeleteIcon from '@mui/icons-material/Delete'
import EditIcon from '@mui/icons-material/Edit'
import RotateLeftIcon from '@mui/icons-material/RotateLeft'

import { Visibility, VisibilityOff } from '@mui/icons-material'
import { IconButton } from '@mui/material'

import config from '../../config/config.json'
import { UsersTableActionButton, UsersTableDataGrid, UsersTablePaper } from '../../styles/components/UsersTableStyle'

const ROWS_PER_RENDER = config.rowsPerRender

const getIcon = (name) => {
  switch (name) {
    case 'DeleteIcon':
      return <DeleteIcon aria-label="userDeleteButton" />
    case 'EditIcon':
      return <EditIcon aria-label="userEditButton" />
    case 'RotateLeftIcon':
      return <RotateLeftIcon aria-label="userChangePasswordButton" />
    default:
      return null
  }
}

const getPasswordField = (visiblePwdIndex, setVisiblePwdIndex) => {
  const PasswordField = (params) => {
    const isPasswordHidden = params.row.id !== visiblePwdIndex
    return (
      <div>
        <input
          type={isPasswordHidden ? 'password' : 'text'}
          value={params.row.password}
          style={{ border: 'none', background: 'inherit' }}
          disabled
        />
        <IconButton
          aria-label="toggle password visibility"
          onClick={() => (isPasswordHidden ? setVisiblePwdIndex(params.row.id) : setVisiblePwdIndex(null))}
          edge="end"
          tabIndex="-1"
        >
          {isPasswordHidden ? <Visibility /> : <VisibilityOff />}
        </IconButton>
      </div>
    )
  }
  return PasswordField
}

const getUserActions = (actions, actionCalls) => {
  const UserActions = (params) => {
    return (
      <UsersTableActionButton>
        {actions.map((action) => (
          <UserAction
            disabled={actionCalls[action.name].disabledIndex === params.row.id}
            key={action.name}
            label={action.label}
            action={() => actionCalls[action.name].callback(params.row.id)}
          >
            {getIcon(action.icon)}
          </UserAction>
        ))}
      </UsersTableActionButton>
    )
  }
  return UserActions
}

const UsersTable = ({ rows, columns, loading = false, tableSize, actionCalls, setCurrentPage }) => {
  const [visiblePwdIndex, setVisiblePwdIndex] = useState(null)
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 100, page: 0
  })
  // TODO: Preparation for paging using cursors.
  void tableSize;
  void setCurrentPage;

  const parsedColumns = columns.map((col) => {
    const column = {
      ...col,
    }
    if (col.isPasswordField) {
      column.renderCell = getPasswordField(visiblePwdIndex, setVisiblePwdIndex)
    }
    if (col.showActions) {
      column.renderCell = getUserActions(col.showActions, actionCalls)
    }
    return column
  })

  const handlePageChange = (model) => {
    setPaginationModel(model)
    // setCurrentPage(model.page)
  }

  return (
    <UsersTablePaper>
      <UsersTableDataGrid
        rows={rows}
        columns={parsedColumns}
        pageSizeOptions={[ROWS_PER_RENDER, 64, 100]}
        loading={loading}
        paginationModel={paginationModel}
        onPaginationModelChange={handlePageChange}
        disableRowSelectionOnClick
        aria-label="usersTable"
        // rowCount={tableSize}
        // paginationMode="server"
      />
    </UsersTablePaper>
  )
}

UsersTable.propTypes = {
  rows: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  loading: PropTypes.bool,
  actionCalls: PropTypes.object,
  tableSize: PropTypes.number,
  setCurrentPage: PropTypes.func,
}

export default UsersTable
